<template>
  <div id="agent" class="div-flex-center" v-loading="loading">
    <!-- 代理管理 -->
    <div class="left div-flex-column-center">
      <div
        :class="{
          menu: true,
          'div-flex-center': true,
          'is-active': isActive == item.name,
        }"
        v-show="item.auth == '1'"
        v-for="(item, index) in menus"
        :key="index"
        @click="jump(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="right"><router-view /></div>
  </div>
</template>

<script>
export default {
  inject: ["reload"],
  data() {
    return {
      isActive: "备案申请",
      loading: true,
      menuList: [
        "/main/agent/contract_records",
        "/main/agent/documents_management",
        "/main/agent/agent_management",
      ],
      menus: [
        {
          id: "",
          name: "备案申请",
          auth: "2",
          path: "/main/agent/contract_records",
        },
        {
          id: "",
          name: "凭证管理", // 您还未完成备案申请，请先前往代理备案。
          auth: "2",
          path: "/main/agent/documents_management",
        },
        {
          id: "",
          name: "合作商",
          auth: "2",
          path: "/main/agent/agent_management",
        },
        {
          id: "",
          name: "区域审核",
          auth: "2",
          path: "/main/agent/agent_create",
        },
        // {
        //   id: "",
        //   name: "作废地址",
        //   auth: "2",
        //   path: "/main/agent/agent_cancellation",
        // },
        {
          id: "",
          name: "优质号段",
          auth: "2",
          path: "/main/agent/agent_address",
        },
      ],
      userData: {
        userId: "",
        userName: "",
        icon: "",
      },
    };
  },
  methods: {
    /**
     * 路由跳转
     */
    jump(data) {
      sessionStorage.setItem("childernMenu", JSON.stringify(data));
      sessionStorage.setItem("path", data.path);
      this.isActive = data.name;
      this.$router.push({
        path: data.path,
        query: {
          name: data.name,
        },
      });
      this.reload();
    },
  },
  mounted() {
    this.loading = true;
    this.userData = JSON.parse(sessionStorage.getItem("userData"));
    this.$baseData.getUserAuthority(this.userData.userId, this, (data) => {
      this.menus = this.$baseData.judgeDirectoryPermissions(
        data,
        this.menus,
        "代理管理"
      );
    });

    setTimeout(() => {
      console.log(this.menus);
      let name = "";
      let path = "";
      let tempMenuList = [];
      for (let i = 0; i < this.menus.length; i++) {
        if (this.menus[i].auth == 1 || this.menus[i].auth == "1") {
          name = this.menus[i].name;
          path = this.menus[i].path;
          break;
        }
      }
      this.menus.forEach((element) => {
        if (element.auth == 1 || element.auth == "1") {
          tempMenuList.push(element.path);
        }
      });
      console.log(name, path, tempMenuList);
      this.isActive =
        sessionStorage.getItem("childernMenu") &&
        tempMenuList.indexOf(
          JSON.parse(sessionStorage.getItem("childernMenu")).path
        ) >= 0
          ? JSON.parse(sessionStorage.getItem("childernMenu")).name
          : name;
      path =
        sessionStorage.getItem("childernMenu") &&
        tempMenuList.indexOf(
          JSON.parse(sessionStorage.getItem("childernMenu")).path
        ) >= 0
          ? JSON.parse(sessionStorage.getItem("childernMenu")).path
          : path;
      console.log(this.isActive);
      this.$router.push({
        path: path,
        query: {
          name: this.isActive,
        },
      });
      this.loading = false;
    }, 1000);
  },
};
</script>

<style lang="less" scoped>
#agent {
  width: 100%;
  height: 100%;
  .left {
    width: 15%;
    height: 100%;
    box-sizing: border-box;
    border-right: 1px solid @borderColor;
    // border-left: 1px solid @borderColor;

    .menu {
      width: 100%;
      height: 8%;
      border-bottom: 1px solid #33333300;
      border-left: 1px solid #33333300;
      box-sizing: border-box;
      transition: 0.3s;
      &:hover {
        cursor: pointer;
        background-color: rgba(201, 201, 201, 0.212);
        border-left: 5px solid @activeColor;
        color: @activeColor;
      }
    }
    .is-active {
      background-color: rgba(201, 201, 201, 0.212);
      border-left: 5px solid @activeColor;
      color: @activeColor;
    }
  }
  .right {
    width: 0;
    height: 100%;
    flex: 1;
    overflow: hidden;
  }
}
</style>
